import React from 'react';

const Notification = ({ errorMessage, containerClasses }) => {
  return (
    <div className={ `flex flex-column flex-ai-center mx-auto ${ containerClasses }` }>
      <div className='bg-red-5 p4 mb-4'>
        <p className='small color-red'>{ errorMessage }</p>
      </div>
    </div>
  );
};

export default Notification;
